var map = {
	"./courses2024S-O.json": 3479,
	"./courses2024S-V.json": 150,
	"./courses2024W-O.json": 5967,
	"./courses2024W-V.json": 3562,
	"./courses2025W-O.json": 791,
	"./courses2025W-V.json": 3864,
	"./courses2026W-O.json": 4049,
	"./courses2026W-V.json": 5469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3582;